var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-doctors",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        svg#freepik_stories-doctors:not(.animated) .animable {\r\n            opacity: 0;\r\n        }\r\n\r\n        svg#freepik_stories-doctors.animated #freepik--background-simple--inject-38 {\r\n            animation: 1.5s Infinite linear floating;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        @keyframes floating {\r\n            0% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n\r\n            50% {\r\n                transform: translateY(-10px);\r\n            }\r\n\r\n            100% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n        }\r\n\r\n        .animator-hidden {\r\n            display: none;\r\n        }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-38",
    className: "animable",
    style: {
      transformOrigin: "232.774px 227.356px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.74,251.81C26.29,333.47,178.13,372,259.27,360.1c102.65-15,160.51-71,158.94-157.25-1.55-85.46-97.86-134.42-170.42-98.39-35.76,17.76-61.95,50-97.62,68.44C107.83,194.85,64.39,200.78,49.74,251.81Z",
    style: {
      fill: "#16A085",
      transformOrigin: "232.774px 227.356px"
    },
    id: "elcuuz1h43ri9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8cs7vprdvhh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.74,251.81C26.29,333.47,178.13,372,259.27,360.1c102.65-15,160.51-71,158.94-157.25-1.55-85.46-97.86-134.42-170.42-98.39-35.76,17.76-61.95,50-97.62,68.44C107.83,194.85,64.39,200.78,49.74,251.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "232.774px 227.356px"
    },
    className: "animable",
    id: "elacvjyc5wsxl"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-38",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-38",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-38",
    className: "animable",
    style: {
      transformOrigin: "162.153px 253.29px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,101.38c-7.55-7.09-20-8.45-24.66-1.07s-2,15.18-11.56,23.36c-6.5,5.59-1.68,22.72,35.4,21.15,17.55-.74,11.61-19,11.14-27.63S173.82,98,164,101.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.503px 120.151px"
    },
    id: "elip3d9bgjkz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.39 402.42 140.41 402.77 140.24 393.05 149.22 392.7 149.39 402.42",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "144.815px 397.735px"
    },
    id: "el53zwh4km9y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.85,400.91H150a.78.78,0,0,1,.77.61l1.76,8.05a1.34,1.34,0,0,1-1.33,1.61c-3.55-.06-5.27-.27-9.74-.27-2.75,0-9.88.29-13.68.29s-4.28-3.76-2.73-4.1c7-1.53,11.07-3.63,13.31-5.64A2.2,2.2,0,0,1,139.85,400.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.391px 406.055px"
    },
    id: "elco832lp7to",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9hksqp9ntsl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "140.24 393.06 140.32 397.58 149.3 397.19 149.22 392.71 140.24 393.06",
    style: {
      opacity: 0.2,
      transformOrigin: "144.77px 395.145px"
    },
    className: "animable",
    id: "el0dvnvpa91xy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127,206.65c-2,10.78.3,63.47,3.35,86.74,4.06,30.9,8.26,102.65,8.26,102.65l12-.72s3-75.56.55-100.37c1.39-31.93,4.83-87.7,4.83-87.7Z",
    style: {
      fill: "#16A085",
      transformOrigin: "141.12px 301.345px"
    },
    id: "elkxd4bp3ffc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqhpmya8xh6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154,242c.42-8.09-5.31-15.28-7.62,0-1.46,9.71,1.56,26.73,5.52,38.75C152.51,268.24,153.29,254.31,154,242Z",
    style: {
      opacity: 0.2,
      transformOrigin: "150.014px 256.894px"
    },
    className: "animable",
    id: "elx0qkc6kb52g"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "215.37 372.19 209.53 377.77 201.62 369.29 207.45 363.72 215.37 372.19",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "208.495px 370.745px"
    },
    id: "el21qalqaica",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,377.92l6-8.22a.68.68,0,0,1,.91-.2l7,4.12a1.54,1.54,0,0,1,.4,2.18c-2.13,2.83-3.3,4.08-5.93,7.7-1.62,2.22-3.49,5.28-5.72,8.36s-5.28.87-4.62-.62c3-6.69,1.73-8.55,1.57-11.74A2.48,2.48,0,0,1,208,377.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.273px 381.407px"
    },
    id: "elvm2371zj8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elthx9w7es8zc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "201.62 369.3 205.7 373.66 211.49 368.04 207.46 363.72 201.62 369.3",
    style: {
      opacity: 0.2,
      transformOrigin: "206.555px 368.69px"
    },
    className: "animable",
    id: "eljxz9dbz1ncg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.92,206.94s12.92,68,16.28,94.4c2,15.77,46.1,72.51,46.1,72.51l7.53-7.93s-16.14-41.54-35.58-66.18c-.77-28.88,2.51-76.42-8.65-92.27Z",
    style: {
      fill: "#16A085",
      transformOrigin: "175.875px 290.395px"
    },
    id: "elvl6n7vkuq4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,154.8c0,5.84-.27,11.57-.7,17.36s-1,11.55-1.93,17.35l-.17,1.09-.23,1.23q-.26,1.21-.57,2.37c-.44,1.53-1,3-1.5,4.42a84.16,84.16,0,0,1-3.72,8.16,118.87,118.87,0,0,1-9.29,14.89,2.48,2.48,0,0,1-4.25-2.5l0-.06c2.35-5.08,4.63-10.29,6.62-15.45,1-2.58,1.89-5.19,2.65-7.75.36-1.28.68-2.55.93-3.79.13-.62.22-1.23.31-1.83l.1-.89.1-1c.51-5.54.81-11.16,1.09-16.79s.41-11.31.57-16.89v-.05a5,5,0,0,1,10,.16Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "118.296px 186.209px"
    },
    id: "elj5upx80t4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.32,147.49c-12.28,3.59-10.7,25.93-10.7,25.93l17.46,4.7s2.9-16.36,2.64-22.23C135.46,149.79,133.09,145.52,126.32,147.49Z",
    style: {
      fill: "#16A085",
      transformOrigin: "125.645px 162.562px"
    },
    id: "el400fspxuf6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,217.88l-6.15,5.23,8.62,3.52s2.67-4.07,1.43-7.93Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "107.559px 222.255px"
    },
    id: "eltysa54ld1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,231.09l3.93.49a2,2,0,0,0,2.1-1.23l1.5-3.72-8.62-3.52-.65,5.77A2,2,0,0,0,103.46,231.09Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "106.349px 227.353px"
    },
    id: "elcood93gnd4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,153.3c-.55,22.4,4.6,38.75,4.66,53.35l39.59.82c-.29-14.62-.17-24.16,6.12-50.36a8.44,8.44,0,0,0-7-10.32c-2.37-.35-5-.68-7.67-.86a126.39,126.39,0,0,0-18-.38c-4.22.3-8.76.92-12,1.41A6.69,6.69,0,0,0,122.35,153.3Z",
    style: {
      fill: "#16A085",
      transformOrigin: "147.631px 176.43px"
    },
    id: "elk56sfft1j7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.25,174l-11.74-.08a.81.81,0,0,1-.84-.9l.65-5.56a1.07,1.07,0,0,1,1.05-.89l11.73.08a.8.8,0,0,1,.84.89l-.65,5.57A1.06,1.06,0,0,1,159.25,174Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "153.805px 170.285px"
    },
    id: "elo0udgsmdr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltkwwep9odse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.11,145.56s-6.46,4.52.37,15.86a234.05,234.05,0,0,1,17.61-15.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "147.718px 153.49px"
    },
    className: "animable",
    id: "elkssuxp2362f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,125.65c-1.25,5.76-2.61,16.34,1.36,20.28a56.65,56.65,0,0,0-17,10.48c-4.39-8.06-1-10.86-1-10.86,6.48-1.4,6.42-6.19,5.39-10.71Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "148.466px 141.03px"
    },
    id: "elpqn0uva16db",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaxa93vg3ixg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.51,126.65a24.17,24.17,0,0,1-2.61,9.88c-1.09,2.11-4,3-6.93,3.17a15.76,15.76,0,0,0-.47-4.86Z",
    style: {
      opacity: 0.2,
      transformOrigin: "150.505px 133.175px"
    },
    className: "animable",
    id: "eljpafawjmacb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.1,118.6c-3,9.22-4,13.18-10,16.78-8.95,5.41-19.62-.24-19.48-10.15.14-8.92,5-22.49,15.07-23.88A13.2,13.2,0,0,1,166.1,118.6Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "151.7px 119.346px"
    },
    id: "el3pantgsjrsx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,106.49c5,1.41,17.18,2.46,19.62,1-2.29,3.52-.11,13.14,3.43,15.47,4.77-3.83,5.83-13.09,1.42-17.68S147.77,95.2,141.65,106.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.282px 111.393px"
    },
    id: "elwvxfxir49zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,124.24a7,7,0,0,1-3.68,4c-2.26,1-3.76-.92-3.44-3.25.29-2.09,1.82-5.14,4.24-5.18A3.18,3.18,0,0,1,167.5,124.24Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "164.047px 124.161px"
    },
    id: "eltfnfck0zxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,205.16l1.72,3.59c.13.27-.2.55-.66.54l-41.53-.87c-.35,0-.64-.19-.66-.42l-.29-3.55c0-.24.3-.44.69-.44l40.1.84A.71.71,0,0,1,167.24,205.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.404px 206.65px"
    },
    id: "elxann2qzbx9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,209.53l1.07,0c.21,0,.38-.11.37-.24l-.41-4.62c0-.13-.2-.25-.41-.25l-1.08,0c-.21,0-.37.1-.36.24l.4,4.61C161.37,209.42,161.55,209.53,161.77,209.53Z",
    style: {
      fill: "#16A085",
      transformOrigin: "162.08px 206.975px"
    },
    id: "el0sm1gtjadesh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.78,208.87l1.08,0c.21,0,.38-.1.37-.24l-.41-4.62c0-.13-.2-.24-.41-.25l-1.08,0c-.21,0-.38.1-.36.24l.4,4.61C129.39,208.75,129.57,208.86,129.78,208.87Z",
    style: {
      fill: "#16A085",
      transformOrigin: "130.099px 206.315px"
    },
    id: "elczz8ssdp0pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,209.2l1.08,0c.21,0,.38-.1.37-.24l-.41-4.61c0-.14-.2-.25-.41-.25l-1.08,0c-.21,0-.37.11-.36.24l.4,4.62C145.38,209.08,145.56,209.2,145.77,209.2Z",
    style: {
      fill: "#16A085",
      transformOrigin: "146.09px 206.65px"
    },
    id: "eln6bky6je5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.71,117.83c-.2.76-.76,1.28-1.26,1.15s-.74-.85-.55-1.61.76-1.28,1.26-1.15S151.9,117.07,151.71,117.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.805px 117.6px"
    },
    id: "el6e8037y792a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,115.63c-.19.77-.75,1.28-1.25,1.15s-.75-.84-.55-1.61.75-1.27,1.25-1.15S143.29,114.87,143.09,115.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.19px 115.401px"
    },
    id: "elr4ng98d2hvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,114.12l-1.7-1S141.63,114.8,142.75,114.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.9px 113.701px"
    },
    id: "elrixzbrqfqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,117.52a21.08,21.08,0,0,1-3.95,4.18,3.38,3.38,0,0,0,2.58,1.2Z",
    style: {
      fill: "rgb(160, 39, 36)",
      transformOrigin: "143.025px 120.21px"
    },
    id: "eliyc9p8xoxtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,125.89a.25.25,0,0,1-.08-.25.23.23,0,0,1,.29-.15,6.25,6.25,0,0,0,5.56-.92.23.23,0,0,1,.3.35,6.57,6.57,0,0,1-6,1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.511px 125.38px"
    },
    id: "elhl3th1c4vpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41,114.32a.7.7,0,0,1-.15-.19,3.65,3.65,0,0,0-2.48-2.23.46.46,0,0,1,.16-.91,4.61,4.61,0,0,1,3.18,2.78.47.47,0,0,1-.71.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.274px 112.694px"
    },
    id: "el8nh91wjj6q2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,110.77l-.06-.06a.46.46,0,0,1,0-.65,4.61,4.61,0,0,1,4-1.17.46.46,0,0,1,.33.57.46.46,0,0,1-.56.33,3.65,3.65,0,0,0-3.2.95A.46.46,0,0,1,141.39,110.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.436px 109.822px"
    },
    id: "elq0fjsx10oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,153.86c2.91,3.85,5.63,7.73,8.27,11.76,1.31,2,2.61,4,3.84,6.16a62.15,62.15,0,0,1,3.56,6.78,20.32,20.32,0,0,1,.82,2.23,10.2,10.2,0,0,1,.34,1.79,5.38,5.38,0,0,1,0,.73l0,.45a5,5,0,0,1-.09.59l-.07.31,0,.14v0l0,.11-.08.22c-.47,1.2-.84,2.41-1.4,3.57a44.8,44.8,0,0,1-3.64,6.83,34.09,34.09,0,0,1-5.06,6,24.61,24.61,0,0,1-3.13,2.49c-.57.37-1.15.73-1.75,1.06l-.95.46c-.36.16-.62.27-1.14.46l-1.9-4.56a4.43,4.43,0,0,1,.43-.37l.55-.48c.37-.33.73-.69,1.08-1.06a27.18,27.18,0,0,0,2-2.41,35.12,35.12,0,0,0,3.18-5.45c.42-1,.88-1.94,1.23-3s.74-2,1.06-3,.57-2.1.88-3.14l0-.19,0-.1v0l0,.09,0,.2c0,.12-.05.3-.06.37a1.79,1.79,0,0,0,0,.23v.29c0,.23,0,.16,0,.06s-.28-.64-.49-1.06c-.91-1.71-2.13-3.68-3.38-5.56s-2.55-3.81-3.88-5.7c-2.65-3.79-5.38-7.62-8.06-11.38Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "177.211px 179.93px"
    },
    id: "elqssxq7e6bk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,204.82l-7.71,5.45-3.46-7.88s4.68-2.51,8.37-.83Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "169.295px 205.625px"
    },
    id: "el9pljvcqp8xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.8,210.92l-1.93-2.69a2.44,2.44,0,0,1,.53-3.36l3.31-2.48,3.46,7.88-2.12,1.31A2.43,2.43,0,0,1,161.8,210.92Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "163.297px 207.165px"
    },
    id: "el27eogoj4aoy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,151.48c-2.62,10.41,13.54,28.23,13.54,28.23l13.59-14.11s-6.21-13.26-14.32-17.42C164.43,145.28,158.44,146.89,157.28,151.48Z",
    style: {
      fill: "#16A085",
      transformOrigin: "170.701px 163.218px"
    },
    id: "el8t2xs02w4sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.37,116.32l-1.7-1S150.24,117,151.37,116.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.52px 115.901px"
    },
    id: "elqy1088i6p6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,179.29a.37.37,0,0,1-.34-.23.36.36,0,0,1,.21-.46l1.56-.6a7.65,7.65,0,0,0,5-7.14l.11-14.62A4.86,4.86,0,0,0,131.3,154l-6.76,13a7.68,7.68,0,0,0,1,8.64l1.1,1.25a.36.36,0,1,1-.54.47L125,176a8.35,8.35,0,0,1-1.13-9.44l6.76-13a5.57,5.57,0,0,1,10.51,2.62l-.11,14.62a8.38,8.38,0,0,1-5.42,7.8l-1.56.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.021px 164.926px"
    },
    id: "els85bzn2x7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.79,159.5a.37.37,0,0,1-.36-.35A5.76,5.76,0,0,0,130,156.54a.36.36,0,1,1-.63-.35,6.48,6.48,0,0,1,11.81,2.94.37.37,0,0,1-.35.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.252px 156.421px"
    },
    id: "elnnfw5eympwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,151.51a.37.37,0,0,1-.3-.16,3.14,3.14,0,0,1,0-2.58,5.65,5.65,0,0,1,3.37-3.55.34.34,0,0,1,.45.22.36.36,0,0,1-.22.45A5.06,5.06,0,0,0,137.3,149a2.61,2.61,0,0,0-.11,2,.36.36,0,0,1-.11.5A.41.41,0,0,1,136.89,151.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.37px 148.357px"
    },
    id: "elslc16m4xs37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,178.74c-.17.65,0,1.27.48,1.38s.92-.34,1.08-1-.06-1.28-.49-1.38S133.34,178.08,133.18,178.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.954px 178.931px"
    },
    id: "el1alaspmc8g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,161.47c.32,1.51,1.4,2.55,2.39,2.34s1.53-1.62,1.2-3.12-1.4-2.56-2.39-2.34S161.23,160,161.56,161.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.355px 161.079px"
    },
    id: "elpzlha84ck8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,161a.35.35,0,0,1-.36-.34c-.21-5.53-2.31-12.4-6.4-14.43a.36.36,0,0,1-.16-.48.35.35,0,0,1,.48-.16c4.38,2.17,6.57,9.12,6.79,15a.34.34,0,0,1-.34.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.387px 153.275px"
    },
    id: "elk9nis4u9yzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.49,161.6c.21,1.29,1.14,2.21,2.08,2.06s1.54-1.32,1.33-2.62-1.15-2.21-2.09-2.06S160.28,160.3,160.49,161.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.195px 161.32px"
    },
    id: "elg28foxhkj0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,161.71c.3,1.6,1.14,2.78,1.87,2.64s1.06-1.54.76-3.14-1.14-2.78-1.87-2.64S160.1,160.11,160.41,161.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.723px 161.46px"
    },
    id: "el787kbiz1ofh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,176.85c-.16.66.06,1.28.49,1.38s.91-.33,1.08-1-.06-1.27-.49-1.38S125.79,176.2,125.62,176.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.407px 177.039px"
    },
    id: "elhp9h5ikwbzn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-38",
    className: "animable",
    style: {
      transformOrigin: "224.572px 242.269px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.16,95.42c-6.33,1.13-7.13.55-7.21-4s-2.38-12.14.82-14.52a1.73,1.73,0,0,1,2.87.84,2.08,2.08,0,0,1,2.61-1.21c.13-.94.28-3.35,2-4s3.3.91,3.3.91-.13-3.71,2.37-3.35A3.76,3.76,0,0,1,245,73s1.44-2.1,3.39-1.27S249.93,75,249.93,75s2.07-1,3.61.13.42,2.94.42,2.94,1.4-3.6,4.07-1.61c2.4,1.8.22,4.62.22,4.62s2.64-.43,3.28.9c2.16,4.53-6.07,9.59-6.34,17.24C242.55,104,235.16,95.42,235.16,95.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.483px 85.367px"
    },
    id: "el5d89qbl06wr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.54,217l-4.22-.78-5.58,5.33a3,3,0,0,0-.93,2.25l.08,4.36a3,3,0,0,0,2.75,2.95l1.94.17a3,3,0,0,0,3.18-2.21l1-3.56S193.27,219,189.54,217Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "184.822px 223.757px"
    },
    id: "el6a0vogu37y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.16,137.26c-2.83,7.33-5.65,14.69-8.37,22.07s-5.42,14.79-7.95,22.08l-.45,1.35-.31.88c-.12.33-.24.67-.35.93-.47,1.19-.94,2.17-1.41,3.16-.94,2-1.89,3.79-2.85,5.6-1.93,3.6-3.92,7.07-5.93,10.53-4,6.93-8,13.7-12.14,20.57l-12.73-7.92c4.2-6.53,8.25-13.27,12.13-20,1.91-3.38,3.79-6.77,5.54-10.13.87-1.68,1.71-3.36,2.45-5,.35-.79.7-1.6.93-2.26.08-.19.11-.32.16-.45l.16-.52.46-1.46c2.41-7.68,4.94-15.1,7.38-22.63l7.32-22.51Z",
    style: {
      fill: "#16A085",
      transformOrigin: "205.915px 177.99px"
    },
    id: "elhkbjdfutjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7nz1vmyreb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.16,137.26c-2.83,7.33-5.65,14.69-8.37,22.07s-5.42,14.79-7.95,22.08l-.45,1.35-.31.88c-.12.33-.24.67-.35.93-.47,1.19-.94,2.17-1.41,3.16-.94,2-1.89,3.79-2.85,5.6-1.93,3.6-3.92,7.07-5.93,10.53-4,6.93-8,13.7-12.14,20.57l-12.73-7.92c4.2-6.53,8.25-13.27,12.13-20,1.91-3.38,3.79-6.77,5.54-10.13.87-1.68,1.71-3.36,2.45-5,.35-.79.7-1.6.93-2.26.08-.19.11-.32.16-.45l.16-.52.46-1.46c2.41-7.68,4.94-15.1,7.38-22.63l7.32-22.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "205.915px 177.99px"
    },
    className: "animable",
    id: "eljlhv5rg11w"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "194.02 404.91 185.05 405.35 189.29 381.99 197.82 383.95 194.02 404.91",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "191.435px 393.67px"
    },
    id: "el59vzniauo1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.37 405.25 249.4 405.25 249.43 384.48 258.39 384.48 258.37 405.25",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "253.895px 394.865px"
    },
    id: "elhkb5r3r9qj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,404.21h10.93a.74.74,0,0,1,.74.61l1.44,8a1.38,1.38,0,0,1-1.37,1.6c-3.52-.06-6.08-.27-10.51-.27-2.72,0-11,.28-14.72.28s-4.1-3.72-2.55-4.06c7-1.51,12.27-3.59,14.56-5.58A2.24,2.24,0,0,1,248.55,404.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246.665px 409.32px"
    },
    id: "elj5q8k5gmdgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2dh0bdblu66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "189.29 382 187.33 392.8 195.86 394.76 197.82 383.96 189.29 382",
    style: {
      opacity: 0.2,
      transformOrigin: "192.575px 388.38px"
    },
    className: "animable",
    id: "elsdfqtpn2or"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elw7dd6msy7pe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.42,
    y: 384.48,
    width: 8.97,
    height: 10.7,
    style: {
      opacity: 0.2,
      transformOrigin: "253.905px 389.83px"
    },
    className: "animable",
    id: "elwftqrtud3td"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,137c-7,31.49-5.14,62.57-5.89,69.3l-47.87-3.16c-5-38,.58-62.24,3.75-72.18a9,9,0,0,1,7.44-6.23,137.77,137.77,0,0,1,21.44-.67,80,80,0,0,1,14.36,2.18A9,9,0,0,1,265.61,137Z",
    style: {
      fill: "#16A085",
      transformOrigin: "237.842px 165.105px"
    },
    id: "elv0i0933vbgc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.18,102.72c-1.58,5.93-3.45,16.43-.44,21.74.47.83-.43,1.54-.47,2.5-.11,2.94-4.09,3.82-11.21,3.86s-10.17-2.93-8.23-5.73a2,2,0,0,1,1.26-.82c6.67-1.49,6.8-6.72,5.89-11.71Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "240.719px 116.77px"
    },
    id: "elszz0zy2t7ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5l7ey72u8z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.55,129.19A19.11,19.11,0,0,1,242,138c7.11-3.34,10.5-11.45,10.5-11.45l-2.14-2.29S242.46,125.75,238.55,129.19Z",
    style: {
      opacity: 0.4,
      transformOrigin: "245.525px 131.13px"
    },
    className: "animable",
    id: "eltbqgeb8xtlb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els4wo7zr5tzd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.85,129.22a27.88,27.88,0,0,0-6.52,7.64C226.36,133.78,228,125,228,125l4.05-.8S233.86,125.87,237.85,129.22Z",
    style: {
      opacity: 0.4,
      transformOrigin: "232.795px 130.53px"
    },
    className: "animable",
    id: "elfpjgjbhk7f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.17,129l-1.53.15-2.59,1.71a4.69,4.69,0,0,0,.52,3,18.35,18.35,0,0,0,4.57.31,4.83,4.83,0,0,0,2.31-2.38l-1.9-2.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.72px 131.6px"
    },
    id: "eltx62kogn9g9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.17,129a25.69,25.69,0,0,1,4.35,8.06c7.11-3.34,11.25-11.32,11.25-11.32l-3.43-3S242.08,125.58,238.17,129Z",
    style: {
      fill: "#16A085",
      transformOrigin: "245.97px 129.9px"
    },
    id: "els1fv3l9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.17,129a26.31,26.31,0,0,0-7.08,6.56c-5-3.07-3.09-11.34-3.09-11.34l4.05-.8S234.19,125.67,238.17,129Z",
    style: {
      fill: "#16A085",
      transformOrigin: "232.906px 129.49px"
    },
    id: "elosens9f2m7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo00bip565yp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.8,106.73,238,112.55a21,21,0,0,1,.39,3.65c2.81-.21,6.85-3,7.34-5.92A10,10,0,0,0,245.8,106.73Z",
    style: {
      opacity: 0.2,
      transformOrigin: "241.963px 111.465px"
    },
    className: "animable",
    id: "el2gy9rd33t2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,92.92c-1.13,8.83-1.34,14-6.12,18.31-7.19,6.39-17.86,1.61-19.39-7.38-1.38-8.09.7-21.17,9.61-24.12A12.14,12.14,0,0,1,252.61,92.92Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "239.719px 96.6276px"
    },
    id: "eltwiyy8r6jjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.45,100.9c-2-1.93-.75-11.17.26-13.82-5,.48-21.16.46-20.55-4s6.49-8.25,16.1-5.12c8,2.61,10,6.6,10,9.86C256.38,94.52,250.45,100.9,250.45,100.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.202px 88.8559px"
    },
    id: "elgd7loali2t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.71,101a7.84,7.84,0,0,1-4.52,3.82c-2.55.79-3.81-1.56-3.09-4.08.64-2.26,2.75-5.41,5.3-5.09S256.88,98.75,255.71,101Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "252.055px 100.301px"
    },
    id: "elrf1vh8ihjac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,390.06l14.83,3.27s14.42-56.51,18.7-84.13c1.31-8.4,4.35-20.39,7.12-33,3.49-15.9,7.88-33.1,11.48-46.57,3.8-14.19,6.62-24.39,6.62-24.39l-31.31-2.07s-14.57,73.91-17.51,101.12C191.27,332.57,184.41,390.06,184.41,390.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.785px 298.25px"
    },
    id: "elp9w9favu6wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elscrxub1xtnn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.06,276.18c3.49-15.9,7.88-33.1,11.48-46.57l-3.29-7C225.48,231.89,223.49,260.6,225.06,276.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "230.551px 249.395px"
    },
    className: "animable",
    id: "eljz77go2ktr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,204.13s6.48,75.53,9,101.68c2.8,28.64,10.31,87.31,10.31,87.31h15.06s.68-62.48-2-90.14c-.38-54.38.57-96.67.57-96.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.994px 298.625px"
    },
    id: "elo2izla8n8z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.16 393.47 263.5 393.47 263.5 387.69 243.41 386.58 244.16 393.47",
    style: {
      fill: "#16A085",
      transformOrigin: "253.455px 390.025px"
    },
    id: "elxeq7z2bwptn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.47 390 200.14 393.9 201.4 388.19 182.9 383.53 182.47 390",
    style: {
      fill: "#16A085",
      transformOrigin: "191.935px 388.715px"
    },
    id: "elas0nl2b8yt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,94.5c0,.72-.47,1.28-.94,1.25s-.82-.64-.77-1.36.47-1.28.94-1.25S239.75,93.78,239.7,94.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.845px 94.445px"
    },
    id: "elu12wc5423rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,94c0,.72-.47,1.28-.94,1.25s-.82-.64-.77-1.36.47-1.28.94-1.25S231.59,93.24,231.54,94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.685px 93.945px"
    },
    id: "eli6i5q5vhq1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.41,94.5a26.16,26.16,0,0,1-3.85,5.94c1.19,1.28,3.4.88,3.4.88Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "231.485px 97.9396px"
    },
    id: "el7okbc71704m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,103.45a6,6,0,0,0,4.23-2.1.21.21,0,0,0,0-.29.22.22,0,0,0-.3,0A5.75,5.75,0,0,1,235,103a.21.21,0,0,0-.23.19.22.22,0,0,0,.2.23A7.52,7.52,0,0,0,235.88,103.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.469px 102.227px"
    },
    id: "elxqzsuzjw75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69,92a.48.48,0,0,0,.2-.07.43.43,0,0,0,.13-.59,4.25,4.25,0,0,0-3.34-2,.43.43,0,0,0,0,.85h0a3.38,3.38,0,0,1,2.63,1.6A.41.41,0,0,0,241.69,92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "240.201px 90.6703px"
    },
    id: "eluk0p4o0vyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51,90.93a.43.43,0,0,0,.34-.21A3.37,3.37,0,0,1,230.37,89a.44.44,0,0,0,.4-.45.43.43,0,0,0-.45-.4,4.22,4.22,0,0,0-3.21,2.19.42.42,0,0,0,.16.57A.36.36,0,0,0,227.51,90.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "228.914px 89.5457px"
    },
    id: "el3zywh74yy4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,405.77a10.77,10.77,0,0,0,2.36-.32.21.21,0,0,0,.16-.17.19.19,0,0,0-.08-.21c-.32-.21-3.14-2-4.16-1.48a.71.71,0,0,0-.38.6,1.24,1.24,0,0,0,.39,1.13A2.63,2.63,0,0,0,245.52,405.77Zm1.75-.62c-1.53.31-2.7.25-3.17-.16a.82.82,0,0,1-.26-.77c0-.16.08-.22.14-.25C244.51,403.71,246.13,404.47,247.27,405.15Z",
    style: {
      fill: "#16A085",
      transformOrigin: "245.724px 404.638px"
    },
    id: "el3xm1rtth4q7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.83,405.46a.15.15,0,0,0,.11,0,.21.21,0,0,0,.11-.19c0-.11-.11-2.7-1.12-3.55a1.13,1.13,0,0,0-.9-.27h0a.71.71,0,0,0-.69.55c-.23,1,1.48,3,2.39,3.47A.17.17,0,0,0,247.83,405.46Zm-1.66-3.64a.72.72,0,0,1,.48.19c.64.54.87,2.05.94,2.81-.89-.7-2-2.19-1.84-2.78,0-.05,0-.18.32-.21h.1Z",
    style: {
      fill: "#16A085",
      transformOrigin: "246.685px 403.456px"
    },
    id: "ellmqp8de5th9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,401.4l10.52,3a.75.75,0,0,1,.54.79l-.78,8.07a1.39,1.39,0,0,1-1.76,1.16c-3.37-1-5.77-1.91-10-3.12-2.62-.74-11.15-3.8-14.26-5.92s-1.28-5.39.19-4.79c6.61,2.68,11.26,2.25,14,1A2.27,2.27,0,0,1,183.71,401.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.522px 407.496px"
    },
    id: "elg8yf8hp1qb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,402.08a11.39,11.39,0,0,0,2.36.33.22.22,0,0,0,.21-.12.2.2,0,0,0,0-.23c-.25-.28-2.48-2.76-3.59-2.55a.74.74,0,0,0-.54.48,1.25,1.25,0,0,0,.07,1.18A2.68,2.68,0,0,0,180.36,402.08Zm1.86-.12c-1.56-.12-2.67-.5-3-1a.85.85,0,0,1,0-.81c.06-.16.14-.19.21-.2C180,399.82,181.3,401,182.22,402Z",
    style: {
      fill: "#16A085",
      transformOrigin: "180.825px 400.954px"
    },
    id: "el6u6jme5gzb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,402.4a.24.24,0,0,0,.12,0,.22.22,0,0,0,.16-.16c0-.1.62-2.62-.11-3.72a1.15,1.15,0,0,0-.79-.5h0a.72.72,0,0,0-.82.34c-.5.9.62,3.26,1.35,4A.2.2,0,0,0,182.67,402.4Zm-.61-3.95a.7.7,0,0,1,.41.31c.48.7.28,2.22.15,3-.67-.91-1.31-2.64-1-3.17,0-.05.09-.16.37-.12h0Z",
    style: {
      fill: "#16A085",
      transformOrigin: "182.151px 400.201px"
    },
    id: "ele7tjdenbx3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33,123.68a.71.71,0,0,0-.82.76c.35,5.36-8,15-10,43.87-1.19,17.56-2.28,72.31-1.48,100.79a2.46,2.46,0,0,0,3.13,2.29c14.76-4.12,21.73,5.87,24.57-5.91-.15-14.11-4.42-64.77-3.32-76.78s5.67-44.64,6.81-53.34C271.23,127.8,255.46,124.43,251.33,123.68Z",
    style: {
      fill: "#16A085",
      transformOrigin: "254.511px 197.577px"
    },
    id: "eloho4rbsvche",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2sik3g7do21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.33,123.68a.71.71,0,0,0-.82.76c.35,5.36-8,15-10,43.87-1.19,17.56-2.28,72.31-1.48,100.79a2.46,2.46,0,0,0,3.13,2.29c14.76-4.12,21.73,5.87,24.57-5.91-.15-14.11-4.42-64.77-3.32-76.78s5.67-44.64,6.81-53.34C271.23,127.8,255.46,124.43,251.33,123.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "254.511px 197.577px"
    },
    className: "animable",
    id: "ellzxr789lcpq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljbwxvo7gnk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.06,148.15c-.65,4.46-.9,22.48,3.39,31.15.72-6,1.66-13.13,2.57-20Z",
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "263.857px 163.725px"
    },
    className: "animable",
    id: "elpgym2uw07ok"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.19,226.08l-4.26.5-3.77,6.73a3,3,0,0,0-.24,2.42l1.36,4.14a3,3,0,0,0,3.5,2l1.9-.4a3,3,0,0,0,2.4-3.06l-.12-3.68S271.34,226.92,267.19,226.08Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "264.013px 234.01px"
    },
    id: "eljdwzdnb2apn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.53,132c1.36,4,2.62,7.95,3.87,11.95s2.5,8,3.68,12,2.32,8.09,3.37,12.26c.52,2.09,1,4.2,1.46,6.41.21,1.11.42,2.24.59,3.44.08.62.17,1.19.22,1.88l.09,1,.05,1.13a10.86,10.86,0,0,1,0,1.14c0,.4,0,.78-.05,1.09l-.09,1-.11.9c-.14,1.21-.32,2.31-.5,3.41-.36,2.18-.78,4.28-1.21,6.36-.86,4.16-1.82,8.23-2.79,12.28s-2,8.09-3,12.12l-3,12.09-14.48-3.93c2.24-7.81,4.28-15.76,6.17-23.66.92-4,1.78-7.92,2.55-11.83.38-2,.74-3.9,1-5.78.15-.94.27-1.87.35-2.71a13.07,13.07,0,0,0,.08-2l0-.42-.07-.54c0-.34-.12-.79-.18-1.18-.14-.84-.32-1.73-.52-2.64-.41-1.82-.9-3.7-1.43-5.59-1-3.79-2.27-7.63-3.56-11.45-2.55-7.64-5.42-15.33-8.38-22.81Z",
    style: {
      fill: "#16A085",
      transformOrigin: "268.257px 182.23px"
    },
    id: "eloahmef5yd3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3jd20lod6j8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.53,132c1.36,4,2.62,7.95,3.87,11.95s2.5,8,3.68,12,2.32,8.09,3.37,12.26c.52,2.09,1,4.2,1.46,6.41.21,1.11.42,2.24.59,3.44.08.62.17,1.19.22,1.88l.09,1,.05,1.13a10.86,10.86,0,0,1,0,1.14c0,.4,0,.78-.05,1.09l-.09,1-.11.9c-.14,1.21-.32,2.31-.5,3.41-.36,2.18-.78,4.28-1.21,6.36-.86,4.16-1.82,8.23-2.79,12.28s-2,8.09-3,12.12l-3,12.09-14.48-3.93c2.24-7.81,4.28-15.76,6.17-23.66.92-4,1.78-7.92,2.55-11.83.38-2,.74-3.9,1-5.78.15-.94.27-1.87.35-2.71a13.07,13.07,0,0,0,.08-2l0-.42-.07-.54c0-.34-.12-.79-.18-1.18-.14-.84-.32-1.73-.52-2.64-.41-1.82-.9-3.7-1.43-5.59-1-3.79-2.27-7.63-3.56-11.45-2.55-7.64-5.42-15.33-8.38-22.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "268.257px 182.23px"
    },
    className: "animable",
    id: "el5q3y7zzl335"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,122.93a1.16,1.16,0,0,1,.91,1.89c-2.38,2.76-3.88,6.55-6.7,18.71-3.4,14.67-10.64,88.48-12,124.65a2.08,2.08,0,0,1-2.45,2c-7.06-1.3-11.9,2.12-12.67-2.41-.85-5,2.32-52.76,8.25-75.22-.93-19.92,2.43-59.88,9.14-65.19C220,124.41,227.74,123,231.88,122.93Z",
    style: {
      fill: "#16A085",
      transformOrigin: "215.941px 196.572px"
    },
    id: "elu8p8gmyaoum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6dj0328qpah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.88,122.93a1.16,1.16,0,0,1,.91,1.89c-2.38,2.76-3.88,6.55-6.7,18.71-3.4,14.67-10.64,88.48-12,124.65a2.08,2.08,0,0,1-2.45,2c-7.06-1.3-11.9,2.12-12.67-2.41-.85-5,2.32-52.76,8.25-75.22-.93-19.92,2.43-59.88,9.14-65.19C220,124.41,227.74,123,231.88,122.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "215.941px 196.572px"
    },
    className: "animable",
    id: "elvd2llwg3nd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.77,132.84s-8.64,24.27-11.68,44.61c-.24,5.53,2.39,16.24,4.52,20.91,4.45-9.69,7.23-15.4,7.67-20.91.71-8.29,1.88-44.45,1.88-44.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "231.117px 165.6px"
    },
    id: "el5j9u980mu0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,161.71a.4.4,0,0,1-.18-.75l1.64-.86a8.47,8.47,0,0,0,4.54-8.5l-1.78-16.12a5.38,5.38,0,0,0-10.38-1.32l-5.76,15.15a8.48,8.48,0,0,0,2.25,9.37l1.38,1.25a.4.4,0,0,1,0,.56.4.4,0,0,1-.56,0l-1.38-1.24A9.28,9.28,0,0,1,241.19,149L247,133.88a6.18,6.18,0,0,1,11.91,1.52l1.78,16.11a9.28,9.28,0,0,1-5,9.3l-1.64.85A.32.32,0,0,1,253.85,161.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.654px 145.813px"
    },
    id: "el19kasyilhh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81,139a.39.39,0,0,1-.39-.34,5.92,5.92,0,0,0-5.41-4.86c-2.22-.28-5.24.42-6.45,3.34a.4.4,0,1,1-.74-.3,7.18,7.18,0,0,1,13.38,1.71.39.39,0,0,1-.33.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.492px 135.979px"
    },
    id: "el7fcrf4ut0k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,130.73h0a.39.39,0,0,1-.37-.42c.12-1.95-.16-5.5-2-6.42a.4.4,0,0,1,.37-.71c2.66,1.37,2.42,6.59,2.38,7.18A.39.39,0,0,1,253.43,130.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.339px 126.933px"
    },
    id: "ele1mhyk3t9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18,160.33c-.1.75-.57,1.3-1.06,1.23s-.81-.71-.71-1.45.56-1.3,1.05-1.23S246.27,159.59,246.18,160.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.293px 160.22px"
    },
    id: "el79eekomitcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.93,144.12c-.63,1.59-2,2.55-3,2.14s-1.39-2-.76-3.63,2-2.55,3-2.14S223.55,142.53,222.93,144.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.048px 143.374px"
    },
    id: "elyb5xsxhsfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.64,143.09h-.08a.4.4,0,0,1-.31-.47c1.32-6.57,6.78-17,11.59-20a.4.4,0,1,1,.42.67c-4.65,2.93-9.94,13-11.23,19.47A.4.4,0,0,1,219.64,143.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.372px 132.806px"
    },
    id: "ellxngq7jkvzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,144.45c-.46,1.37-1.64,2.22-2.64,1.89s-1.45-1.72-1-3.1,1.64-2.22,2.64-1.89S224.53,143.07,224.07,144.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.252px 143.845px"
    },
    id: "elrdwh1yinmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.14,144.59c-.61,1.69-1.74,2.84-2.51,2.56s-.9-1.88-.28-3.58,1.74-2.84,2.51-2.56S224.76,142.89,224.14,144.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.745px 144.08px"
    },
    id: "elszj0h10012c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.74,161.43c-.09.74-.57,1.29-1.06,1.23s-.81-.72-.71-1.46.57-1.29,1.06-1.23S254.84,160.68,254.74,161.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.855px 161.315px"
    },
    id: "elx3xvh3rqi18",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-38",
    className: "animable",
    style: {
      transformOrigin: "342.217px 253.613px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.44,118.1c3.34,9.13-5.54,13.72-11.36,27.17s8.22,29.49,29.77,29.84,22.23-20.29,18.89-35.1,3.64-17.22,2.16-28.53C349,96.62,327.59,85.36,319.09,99,311.53,98.29,308.52,110.12,311.44,118.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "324.934px 133.985px"
    },
    id: "elm069orrwio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.27,241l0-1.16a3.87,3.87,0,0,0-.41-1.6l-3.62-7.14L367,230.3c-3,3.23,0,9.67,0,9.67V241a3.88,3.88,0,0,0,2.82,3.73l.57.17A3.89,3.89,0,0,0,375.27,241Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "370.47px 237.664px"
    },
    id: "el68cglrfsxto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.3,149.15l1.56,10.94L360.5,171c.54,3.65,1.11,7.28,1.69,10.92l1.73,10.84.21,1.07c.07.35.19.8.28,1.19l.3,1.23.35,1.27c.45,1.68,1,3.42,1.48,5.14,1,3.45,2.15,6.94,3.28,10.41,2.3,6.93,4.7,13.89,7.26,20.73l-14.14,5-7.08-21.14c-1.17-3.53-2.36-7.06-3.49-10.66-.56-1.81-1.12-3.6-1.65-5.47l-.41-1.39-.39-1.45c-.13-.5-.27-.94-.39-1.49l-.37-1.64-2.09-11q-1-5.44-2.09-10.88l-2.14-10.88L340.61,152Z",
    style: {
      fill: "#16A085",
      transformOrigin: "358.845px 193.975px"
    },
    id: "el8c5z2iozcen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxvwa9oilkmj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.3,149.15l1.56,10.94L360.5,171c.54,3.65,1.11,7.28,1.69,10.92l1.73,10.84.21,1.07c.07.35.19.8.28,1.19l.3,1.23.35,1.27c.45,1.68,1,3.42,1.48,5.14,1,3.45,2.15,6.94,3.28,10.41,2.3,6.93,4.7,13.89,7.26,20.73l-14.14,5-7.08-21.14c-1.17-3.53-2.36-7.06-3.49-10.66-.56-1.81-1.12-3.6-1.65-5.47l-.41-1.39-.39-1.45c-.13-.5-.27-.94-.39-1.49l-.37-1.64-2.09-11q-1-5.44-2.09-10.88l-2.14-10.88L340.61,152Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "358.845px 193.975px"
    },
    className: "animable",
    id: "el6re3btb823v"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.05,148.31c.47,5.33.05,18.59-5.3,51.46h-37c.59-14.28.63-23.38-5.5-50.63a4.6,4.6,0,0,1,3.75-5.56,101.37,101.37,0,0,1,10.91-1.19,117.9,117.9,0,0,1,16.82,0c4.6.42,9.59,1.25,12.61,1.8A4.58,4.58,0,0,1,355.05,148.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.165px 170.93px"
    },
    id: "elri1essluzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.54,123.45c1.06,5.41,2.12,15.33-1.67,18.94,0,0,4.74,5.76,12,5.76s4.83-5.76,4.83-5.76c-6-1.44-5.88-5.92-4.83-10.12Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "330.48px 135.8px"
    },
    id: "el0sq38as1bjyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6wtqpj9ztl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.75,127.05l6.11,5.21a17.68,17.68,0,0,0-.52,3c-2.31-.33-5.93-2.3-6.43-4.81C326.68,129.26,327.55,127.61,327.75,127.05Z",
    style: {
      opacity: 0.2,
      transformOrigin: "330.366px 131.155px"
    },
    className: "animable",
    id: "el2nv2xabhfc1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,112.83c1.41,8.94,1.82,12.75,6.8,16.93,7.5,6.29,18.17,2.6,19.46-6.58,1.16-8.26-1.35-21.5-10.49-24.23A12.35,12.35,0,0,0,317.17,112.83Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "330.345px 115.653px"
    },
    id: "elec818p99trc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,119.27c5.12-5.07,6.88-12.12,6.4-15,4.93,1.37,8.55-.57,8.33-1.41,3.48,3.4,9.79,6.09,9.08,2.43s-5.38-10.41-15.12-8S313.86,109.7,314,113.76,318.66,119.27,318.66,119.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.261px 108.026px"
    },
    id: "eleyjdg1ejbzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,113.84c.07.74.51,1.29,1,1.25s.81-.68.74-1.41-.52-1.29-1-1.25S330,113.11,330,113.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.875px 113.76px"
    },
    id: "elc19hs8dimap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.31,113.05c.07.73.52,1.29,1,1.24s.81-.67.74-1.4-.52-1.29-1-1.25S338.24,112.32,338.31,113.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.18px 112.966px"
    },
    id: "elrg3hxdodo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.85,111.7l1.71-.67S339.78,112.49,338.85,111.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.705px 111.482px"
    },
    id: "elx7uwbd4x5z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89,114.61a19.62,19.62,0,0,0,3.05,4.43,3.18,3.18,0,0,1-2.56.74Z",
    style: {
      fill: "rgb(237, 132, 126)",
      transformOrigin: "337.415px 117.213px"
    },
    id: "elg48r13zoivd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,123a8,8,0,0,0,1.09,0,.22.22,0,0,0,.19-.24.2.2,0,0,0-.23-.19,5.85,5.85,0,0,1-4.95-1.82.22.22,0,0,0-.34.27A6.08,6.08,0,0,0,332.66,123Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.167px 121.856px"
    },
    id: "elpcmvnpsik1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,120.1a6.65,6.65,0,0,0,3.56,3.59c2.14.88,3.49-1,3.12-3.13-.33-2-1.85-4.77-4.11-4.73A3,3,0,0,0,315.19,120.1Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "318.419px 119.871px"
    },
    id: "elgx9jj1fr1z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.15,110a.44.44,0,0,0,.49-.14c1.26-1.55,3.83-1.4,3.85-1.4a.44.44,0,0,0,.46-.4.42.42,0,0,0-.4-.46c-.12,0-3.05-.18-4.58,1.72a.44.44,0,0,0,.06.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.413px 108.81px"
    },
    id: "elog678ywx27m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.32,109.09a.43.43,0,0,0,.26-.79,4.31,4.31,0,0,0-3.9-.55.44.44,0,0,0-.23.57.43.43,0,0,0,.57.23,3.42,3.42,0,0,1,3.08.47A.44.44,0,0,0,341.32,109.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.597px 108.301px"
    },
    id: "elff1wa324x3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.74 406.79 381.95 406.35 379.22 385.55 370.02 386 372.74 406.79",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "375.985px 396.17px"
    },
    id: "ellqszx4c228k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbshct10e09n"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "375.32px 391.14px"
    },
    className: "animable",
    id: "eloa20qs2gnm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.22 385.56 380.63 396.28 371.42 396.72 370.01 386 379.22 385.56",
    id: "elbybwqyqtk0d",
    className: "animable",
    style: {
      transformOrigin: "375.32px 391.14px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,199.77s11.59,70.25,16.31,97.64c4.92,28.48,16,95.51,16,95.51l-12.18,2s-16.42-67.1-23-95c-7.14-30.45-24.44-71.28-24.26-100.07Z",
    style: {
      fill: "#16A085",
      transformOrigin: "352.339px 297.345px"
    },
    id: "elxj4soksmqon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5dqcpfizuo2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.14,221.33c-1.74-2.53-5.09-6.08-7.66-9,2.33,17.9,9,38.67,15.09,58.23C340.19,255.66,339.27,233.06,331.14,221.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "331.358px 241.445px"
    },
    className: "animable",
    id: "el9wwxi8s5h7o"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "315.92 405.38 325.04 405.38 325.65 384.26 316.52 384.26 315.92 405.38",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "320.785px 394.82px"
    },
    id: "el89u6cjgzv9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,404H315.22a.73.73,0,0,0-.73.63l-1.17,8.1a1.48,1.48,0,0,0,1.47,1.63c3.57-.07,5.29-.28,9.8-.28,2.77,0,8.5.29,12.33.29s4-3.78,2.44-4.13c-7.15-1.53-10-3.65-12.37-5.68A2.4,2.4,0,0,0,325.47,404Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.798px 409.185px"
    },
    id: "el2mup9d562zt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4abv8agegj3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "320.925px 389.715px"
    },
    className: "animable",
    id: "el5619ozyxpzq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "325.64 384.27 325.33 395.16 316.21 395.16 316.52 384.27 325.64 384.27",
    id: "eleesj7tkrkbd",
    className: "animable",
    style: {
      transformOrigin: "320.925px 389.715px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,199.77s-3.7,71.15-6.2,98.85c-2.61,28.82-5.75,94.13-5.75,94.13H315.05s-2.2-65.06-1.34-93.48c.93-31-6.52-70.71-1.49-99.5Z",
    style: {
      fill: "#16A085",
      transformOrigin: "324.9px 296.26px"
    },
    id: "elx171snp4bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.98 393.19 328.45 393.46 328.67 384.64 313.92 385.56 313.98 393.19",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.295px 389.05px"
    },
    id: "elaw89ongla6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.89,405.63a3.42,3.42,0,0,0,2.21-.56,1.2,1.2,0,0,0,.39-1.06.7.7,0,0,0-.36-.57c-1.12-.62-4.76,1.24-5.17,1.46a.22.22,0,0,0-.11.22.21.21,0,0,0,.17.18A15.11,15.11,0,0,0,328.89,405.63Zm1.63-1.89a.92.92,0,0,1,.4.08.26.26,0,0,1,.14.23.74.74,0,0,1-.25.69c-.55.5-2.05.59-4.07.25A11.69,11.69,0,0,1,330.52,403.74Z",
    style: {
      fill: "#16A085",
      transformOrigin: "328.675px 404.479px"
    },
    id: "el3yad4s367cj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,405.31l.09,0c1.09-.49,3.24-2.46,3.07-3.49,0-.25-.21-.55-.81-.61a1.56,1.56,0,0,0-1.2.37c-1.14.95-1.35,3.41-1.36,3.51a.22.22,0,0,0,.09.2A.25.25,0,0,0,326.06,405.31Zm2.18-3.7h.13c.39,0,.42.19.42.25.11.62-1.35,2.16-2.46,2.83a5,5,0,0,1,1.16-2.81A1.13,1.13,0,0,1,328.24,401.61Z",
    style: {
      fill: "#16A085",
      transformOrigin: "327.539px 403.255px"
    },
    id: "el5r5m3mh4oyy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,404H371.59a.56.56,0,0,0-.59.63l.52,8.1a1.89,1.89,0,0,0,1.8,1.63c3.56-.07,5.24-.28,9.74-.28,2.78,0,8.57.29,12.4.29s3.24-3.78,1.58-4.13c-7.47-1.53-10.73-3.65-13.56-5.68A2.89,2.89,0,0,0,381.84,404Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.661px 409.184px"
    },
    id: "eldemcy0swqy6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.26,405.63a3.45,3.45,0,0,0,2.22-.56,1.22,1.22,0,0,0,.39-1.06.71.71,0,0,0-.37-.57c-1.12-.62-4.75,1.24-5.16,1.46a.22.22,0,0,0-.12.22.23.23,0,0,0,.17.18A15.11,15.11,0,0,0,385.26,405.63Zm1.63-1.89a.86.86,0,0,1,.4.08.27.27,0,0,1,.15.23.79.79,0,0,1-.25.69c-.56.5-2.06.59-4.08.25A11.77,11.77,0,0,1,386.89,403.74Z",
    style: {
      fill: "#16A085",
      transformOrigin: "385.049px 404.479px"
    },
    id: "elyatf2jnohgc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,405.31l.09,0c1.08-.49,3.23-2.46,3.06-3.49,0-.25-.21-.55-.81-.61a1.54,1.54,0,0,0-1.19.37c-1.15.95-1.36,3.41-1.37,3.51a.25.25,0,0,0,.09.2A.28.28,0,0,0,382.44,405.31Zm2.17-3.7h.13c.39,0,.42.19.43.25.1.62-1.36,2.16-2.47,2.83a5.06,5.06,0,0,1,1.16-2.81A1.15,1.15,0,0,1,384.61,401.61Z",
    style: {
      fill: "#16A085",
      transformOrigin: "383.91px 403.255px"
    },
    id: "eltzmstqjgbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.86 395.49 383.15 393.19 381.54 385.55 367.38 388.89 368.86 395.49",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.265px 390.52px"
    },
    id: "eld3py0v5j2qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57,112.49l1.71-.67S331.51,113.28,330.57,112.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.425px 112.272px"
    },
    id: "el9rfv2jxl05i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.15,197.6l-.94,3.32c-.13.25.17.52.6.52h38.12c.34,0,.61-.17.63-.38l.34-3.31c0-.23-.27-.43-.63-.43H312.76A.68.68,0,0,0,312.15,197.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.04px 199.379px"
    },
    id: "elf29fqa6x8m6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.32,201.79h-1c-.2,0-.35-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.34.23l-.48,4.31C317.69,201.69,317.52,201.79,317.32,201.79Z",
    style: {
      fill: "#16A085",
      transformOrigin: "317.08px 199.41px"
    },
    id: "elafesmkxe8nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,201.79h-1c-.2,0-.36-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.34.23l-.47,4.31C347.48,201.69,347.31,201.79,347.11,201.79Z",
    style: {
      fill: "#16A085",
      transformOrigin: "346.869px 199.41px"
    },
    id: "el75dpmwxtv0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.27,201.79h-1c-.2,0-.35-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.33.23l-.47,4.31C332.65,201.69,332.47,201.79,332.27,201.79Z",
    style: {
      fill: "#16A085",
      transformOrigin: "332.026px 199.41px"
    },
    id: "el68jbh74ipe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,142.09c-5.81.53-14.69-.57-14.42,8.34s-1.46,32.51-1,43.56-2.42,82.6,2.24,103.34c.82,3.65,30.92,3.18,34.56,2.83v-3.29s21.87-2.94,27.28-2c-.47-12.46-12.58-75.4-13.05-93.08s1.52-48.06,1.4-52.88-9.7-6.94-15.57-6.82c1.3,4.35-1.57,12.52-6.16,21.63C324.26,152.72,320.93,147.26,320.27,142.09Z",
    style: {
      fill: "#16A085",
      transformOrigin: "336.658px 221.24px"
    },
    id: "elaji2smfay1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsvlrycu95f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.27,142.09c-5.81.53-14.69-.57-14.42,8.34s-1.46,32.51-1,43.56-2.42,82.6,2.24,103.34c.82,3.65,30.92,3.18,34.56,2.83v-3.29s21.87-2.94,27.28-2c-.47-12.46-12.58-75.4-13.05-93.08s1.52-48.06,1.4-52.88-9.7-6.94-15.57-6.82c1.3,4.35-1.57,12.52-6.16,21.63C324.26,152.72,320.93,147.26,320.27,142.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "336.658px 221.24px"
    },
    className: "animable",
    id: "el6zi13a7ovrq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb3wo42zuz2s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.21,163.22l-3.72,2.63c-.29,7.7-.68,16.33-.72,23C308.23,181.2,310.18,170.16,309.21,163.22Z",
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "307.114px 176.035px"
    },
    className: "animable",
    id: "el2q7fyftdpae"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.06,155.23a9.53,9.53,0,0,1-.61.81l-.21.24-.11.12-.2.21-.4.43-.8.89c-.54.59-1.06,1.2-1.58,1.82q-1.56,1.86-3,3.79a92.79,92.79,0,0,0-5.47,8,52.05,52.05,0,0,0-7.06,16.65,28.14,28.14,0,0,0-.47,4,5.09,5.09,0,0,0,.57,1.91,46,46,0,0,0,4.56,7.64c1.85,2.64,3.95,5.21,6.1,7.75,1.08,1.28,2.2,2.52,3.33,3.75s2.31,2.49,3.41,3.58l-10.78,10.42c-1.31-1.43-2.47-2.73-3.68-4.1l-3.53-4.13c-2.34-2.77-4.59-5.65-6.81-8.67a59.69,59.69,0,0,1-6.22-10.22,28,28,0,0,1-1.29-3.44,17.27,17.27,0,0,1-.49-2.13,11.19,11.19,0,0,1-.16-1.25,12.37,12.37,0,0,1-.05-1.32,43.17,43.17,0,0,1,.55-6.41A56.87,56.87,0,0,1,290,173.88a87.81,87.81,0,0,1,5-10.38c1.84-3.3,3.86-6.45,5.95-9.53,1.06-1.54,2.14-3.05,3.27-4.54l1.71-2.23.89-1.12.45-.56.23-.27.1-.13,0,0v0l-.14.16c-.18.23-.35.46-.51.7Z",
    style: {
      fill: "#16A085",
      transformOrigin: "303.584px 186.18px"
    },
    id: "elvuw046hay8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8d9r3f2k1zy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.06,155.23a9.53,9.53,0,0,1-.61.81l-.21.24-.11.12-.2.21-.4.43-.8.89c-.54.59-1.06,1.2-1.58,1.82q-1.56,1.86-3,3.79a92.79,92.79,0,0,0-5.47,8,52.05,52.05,0,0,0-7.06,16.65,28.14,28.14,0,0,0-.47,4,5.09,5.09,0,0,0,.57,1.91,46,46,0,0,0,4.56,7.64c1.85,2.64,3.95,5.21,6.1,7.75,1.08,1.28,2.2,2.52,3.33,3.75s2.31,2.49,3.41,3.58l-10.78,10.42c-1.31-1.43-2.47-2.73-3.68-4.1l-3.53-4.13c-2.34-2.77-4.59-5.65-6.81-8.67a59.69,59.69,0,0,1-6.22-10.22,28,28,0,0,1-1.29-3.44,17.27,17.27,0,0,1-.49-2.13,11.19,11.19,0,0,1-.16-1.25,12.37,12.37,0,0,1-.05-1.32,43.17,43.17,0,0,1,.55-6.41A56.87,56.87,0,0,1,290,173.88a87.81,87.81,0,0,1,5-10.38c1.84-3.3,3.86-6.45,5.95-9.53,1.06-1.54,2.14-3.05,3.27-4.54l1.71-2.23.89-1.12.45-.56.23-.27.1-.13,0,0v0l-.14.16c-.18.23-.35.46-.51.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "303.584px 186.18px"
    },
    className: "animable",
    id: "elfoz53oboelf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhx00jmuv1ev"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.56,163.72c1.05,21.34,6.75,95.76,6.1,133.15l1.74-.23s-2.7-57.5-3.92-82.66S335.56,163.72,335.56,163.72Z",
    style: {
      fill: "#16A085",
      opacity: 0.3,
      transformOrigin: "339.48px 230.295px"
    },
    className: "animable",
    id: "eloti4mam20kq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaoukyacb9eo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.28,217,307.6,228.56c0,3.88-2.71,11.64,4.47,14.46S319.44,225.38,318.28,217Z",
    style: {
      fill: "#16A085",
      opacity: 0.3,
      transformOrigin: "312.956px 230.142px"
    },
    className: "animable",
    id: "elpr655ixnig"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elr021h12r9b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.1,216.64l4.7,11.78c.14,4,1.51,12-1.27,15.05S352.94,225.31,353.1,216.64Z",
    style: {
      fill: "#16A085",
      opacity: 0.3,
      transformOrigin: "355.671px 230.204px"
    },
    className: "animable",
    id: "elx6yoamxepi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.43,171.15l11.73-.08a.81.81,0,0,0,.84-.9l-.65-5.56a1.06,1.06,0,0,0-1-.89l-11.74.07a.82.82,0,0,0-.84.9l.65,5.57A1.07,1.07,0,0,0,341.43,171.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "#16A085",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px",
      transformOrigin: "346.886px 167.435px"
    },
    id: "elnxcaodou9em",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.ea432a09a334cbc79631e3a418480378.svg";
export { ForwardRef as ReactComponent };